import { Button } from "@mui/material";
import { useState } from "react";

const BuyingEmailWizard = ({title, onCancelClick, onNextClick }) => {
  return (
    <div style={{
      margin: '0',
      width: '740px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'flex-start',
      backgroundColor: 'var(--background-lightgray)',
      borderRadius: '2em',
      padding: '3em',
    }}>
      <div style={{display: 'flex', flexDirection:'row', justifyContent:'space-between', width:'100%'}} >
        <h3 style={{fontWeight:'600', color:'var(--orange)', margin:'0 0 1em 0'}} >{title || 'Add New Buying Email'}</h3>
        <p>{`Page ${1} of ${2}`}</p>
      </div>
      
      <div style={{display:'flex', justifyContent:'center', alignItems:'center', margin:'0 0 1em 0', width:'100%'}}>
        <h4 style={{fontWeight:'bold', textAlign:'center'}}>Please read and follow the instructions on <br/> how to create a new Buying Email</h4>
      </div>

      <div style={{margin:'0 0 1em 0', height:'100%'}}>
        <ol style={{fontSize:'1rem'}}>
          <li> Create a new email account on GMAIL.  </li>
          <li> Use a computer when creating a new account, not a mobile device or Chromebook. </li>
          <li> Don't use words like Tix, Tickets, Bee, Encore, Hive, Broker, Swarm, Buyer or any previous email variations in the email address. </li>
          <li> Assign a unique password different from any personal accounts. EncoreHive will use these login credentials to access the mailbox to retrieve receipts and tickets. </li>
          <li> Add a recovery email on the new account as accounts@encorehive.com. Do not use your own personal email! </li>
          <li> Do NOT add a recovery phone number to the account. </li>
        </ol>
      </div>

      <div style={{display: 'flex', flexDirection:'row', justifyContent:'center', width:'100%'}}>
        <Button variant="contained" color="secondary" sx={{width:'100px', margin: '0 2em 0 0'}} onClick={onCancelClick}> Cancel </Button>
        <Button variant="contained" color="primary" sx={{width:'100px'}} onClick={onNextClick} > Next </Button>
      </div>
    </div>
  );
}

export default BuyingEmailWizard;